<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_iii"><span class="small-caps">TO</span></a></p><a id="page_iii">
<p class="dedicationa">R<span class="small-caps">OBERT</span> A. S<span class="small-caps">TURGEON</span></p>
<p class="dedicationa"><span class="small-caps">IN DEEP GRATITUDE</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?581562a6